import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { INotification } from '../../../models/notifications';
import { NotificationsService } from '../../../services/notifications.service';
import { SocketService } from '../../../services/socket.service';
import { Subscription } from 'rxjs';
import { SnackBarService } from '../../../services/snack-bar.service';
import { ConfirmModalComponent } from '../../../modals/confirm-modal/confirm-modal.component';
import { IConfirmModalData } from '../../../modals/confirm-modal/models/confirmModalData';
import { IConfirmModalAnswer } from '../../../modals/confirm-modal/models/confirmModalAnswer';
import { MatDialog } from '@angular/material/dialog';

import { SHARED_MODULES } from '../../../../shared.';
import { LightenColorPipe } from '../../../pipes/lighten-color.pipe';
import { LoaderComponent } from '../../loader/loader.component';
import { PhIconComponent } from '../../ph-icon/ph-icon.component';
import { PhIconWrapperComponent } from '../../ph-icon-wrapper/ph-icon-wrapper.component';
import { SessionService } from '../../../services/session.service';

@Component({
	selector: 'ph-notification[notification]',
	templateUrl: './ph-notification.component.html',
	styleUrls: ['./ph-notification.component.scss'],
	imports: [SHARED_MODULES, LightenColorPipe, LoaderComponent, PhIconComponent, PhIconWrapperComponent],
	standalone: true
})
export class PhNotificationComponent implements OnInit, OnDestroy {

	private _subscriptions: Array<Subscription>;

	public deleteLoader: boolean = false;
	public readLoader: boolean = false;
	public unArchiveLoader: boolean = false;

	@Input() notification: INotification;

	@Output() openDetails: EventEmitter<void> = new EventEmitter<void>();

	constructor(
		private dialog: MatDialog,
		private notificationsService: NotificationsService,
		private socketService: SocketService,
		private snackBarService: SnackBarService,
        private sessionService: SessionService
	) {}

	ngOnInit(): void {
		this._subscriptions = [
			this.socketService.notificationsRead.subscribe((data: { ids: Array<number>})=> {
				if (data?.ids?.includes(this.notification.id)) this.notification.read = true;
			})
		];
	}

	private archive(id: number): void {
		this.deleteLoader = true;
		this.notificationsService.archive({ ids: id }).subscribe({
			error: () => {
				this.snackBarService.setErrorNotification();
				this.deleteLoader = false;
			},
			complete: () => this.deleteLoader = false
		});
	}

	private delete(id: number): void {
		this.deleteLoader = true;
		this.notificationsService.delete({ ids: id }).subscribe({
			error: () => {
				this.snackBarService.setErrorNotification();
				this.deleteLoader = false;
			},
			complete: () => this.deleteLoader = false
		});
	}

	public onDelete(id: number): void {
		const dialogRef = this.dialog.open<ConfirmModalComponent, IConfirmModalData, IConfirmModalAnswer>(ConfirmModalComponent, {
			width: '574px',
			autoFocus: false,
			backdropClass: 'back-drop',
			data: {
				label: this.notification.archived ? 'NOTIFICATIONS.DELETE_WARNING' : 'NOTIFICATIONS.ARCHIVE_WARNING',
				confirmLabel: 'YES',
				cancelLabel: 'NO',
				twoAnswers: true
			}
		});
		dialogRef.afterClosed().subscribe((result: IConfirmModalAnswer) => {
			if (!result.answer) return;

			if (!this.notification.archived) {
				this.archive(id);
			} else {
				this.delete(id);
			}
		});

	}

	public onRead(id: number): void {
		this.readLoader = true;
		this.notificationsService.read({ ids: id }).subscribe({
			error: () => {
				this.snackBarService.setErrorNotification();
				this.readLoader = false;
			},
			complete: () => this.readLoader = false
		});
	}

	public onUnArchive(id: number): void {
		this.unArchiveLoader = true;
		this.notificationsService.unArchive({ ids: id }).subscribe({
			error: () => {
				this.snackBarService.setErrorNotification();
				this.unArchiveLoader = false;
			},
			complete: () => this.unArchiveLoader = false
		});
	}

    public onOpenChat(notification: INotification): void {
        this.sessionService.openChat$.next({
            chatId: notification.action.params.chat_id,
            focusMessageId: notification.action.params.message_id
        });
        this.onRead(notification.id);
    }

	public onOpenDetails(): void {
		this.openDetails.emit();
	}

	ngOnDestroy(): void {
		this._subscriptions.forEach((s: Subscription) => s.unsubscribe());
	}
}
